import { useState } from "react";
import { ArrowRightLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { CrmRecordSummary } from "@/lib/api/crm/masters";
import { useIsDeveloper } from "@/hooks/use-is-developer";
import { MoveRecordMasterDialog } from "./MoveRecordMasterDialog";

/** Developer package only; renders nothing for anyone else. Only offer it for top-level records (no owner). */
export function MoveRecordMasterButton({
  record,
  descendants,
}: {
  record: CrmRecordSummary;
  descendants: CrmRecordSummary[];
}) {
  const isDeveloper = useIsDeveloper();
  const [isOpen, setIsOpen] = useState(false);

  if (!isDeveloper) return null;

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => setIsOpen(true)}
        data-testid={`crm-move-master-${record.id}`}
      >
        <ArrowRightLeft className="mr-2 h-4 w-4" />
        Move to different master record
      </Button>
      {isOpen && (
        <MoveRecordMasterDialog
          record={record}
          descendants={descendants}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
}
